// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingBackdrop_backdrop__PVIB9","loadingIcon":"LoadingBackdrop_loadingIcon__Y2o7M"};